// eslint-disable-next-line n/no-extraneous-import
import type { Component } from '@builder.io/sdk';

import { locales } from './constants/builderLocales';
import developerDefinedTargetingIdList from './constants/developerDefinedTargetingIdList';
import experienceIds from './constants/experienceIds';
import genders from './constants/genders';
import membershipStatuses from './constants/membershipStatuses';

const FableticsTargetedSectionBuilderComponent: Component = {
  name: '_TargetedSection_',
  image:
    'https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2F682efef23ace49afac61748dd305c70a',
  canHaveChildren: true,
  defaultChildren: [
    {
      '@type': '@builder.io/sdk:Element',
      component: {
        name: 'Text',
        options: {
          text: 'Content',
        },
      },
    },
  ],
  noWrap: true,
  inputs: [
    {
      name: 'localeList',
      type: 'Tags',
      enum: locales,
    },
    {
      name: 'membershipStatusList',
      type: 'Tags',
      enum: membershipStatuses,
    },
    {
      name: 'experienceIdList',
      type: 'Tags',
      enum: experienceIds,
    },
    {
      name: 'genderList',
      type: 'Tags',
      enum: genders,
    },
    {
      name: 'developerDefinedTargetingIdList',
      type: 'Tags',
      advanced: true,
      enum: developerDefinedTargetingIdList,
      helperText:
        'Used for specialized targeted experiences. This is NOT for general consumption, requires a discussion with developers to use.',
    },
    {
      name: 'preEmpMemberCreditExpiration',
      friendlyName: 'Pre-Emp Member Credit Expiration',
      type: 'Tags',
      advanced: true,
      enum: ['true', 'false'],
      helperText:
        'SXF Only: When set to "true", this will target members who were members prior to the expiration period being implemented. "false" will will exclude the content from those members. Leave empty to ignore this filter.',
    },
  ],
} as const;

export default FableticsTargetedSectionBuilderComponent;
